import { useEffect, useRef, useState } from 'react';
import ReactLoading from 'react-loading';
import errorHandle from '../../../../utils/errorHandle';
import { getDropdownFun } from '../../../../api/infoAPI';
import { useLocation, useNavigate } from 'react-router-dom';
import DownArrow from '../../../../assets/icons/down-arrow.svg';
import UpArrow from '../../../../assets/icons/up-arrow.svg';
import { orgTripDetailsFun } from '../../../../api/orgTripAPI';
import FAQ from './uploadSec/FAQ/FAQ';
import ImageUpOrg from './uploadSec/images/ImageUpOrg';
import QuickView from './uploadSec/quickView/QuickView';
import InEx from './uploadSec/inEx/InEx';
import Safety from './uploadSec/safety/safety';
import ThingsToCarry from './uploadSec/thingsToCarry/thingsToCarry';
import Terms from './uploadSec/terms/Terms';
import Tags from './uploadSec/tags/Tags';

export default function ListingDetails({ tempData, setTempData, formData, setFormData, imgData, setImgData }) {
    const navigate = useNavigate();
    const location = useLocation();
    const submitRef = useRef(null);

    const basicRef = useRef(null);
    const quickViewRef = useRef(null);
    const itineraryRef = useRef(null);
    const imageRef = useRef(null);
    const inExRef = useRef(null);
    const safetyRef = useRef(null);
    const thingsRef = useRef(null);
    const faqRef = useRef(null);
    const termsRef = useRef(null);
    const priceRef = useRef(null);
    const tagsRef = useRef(null);

    const searchParams = new URLSearchParams(location.search);
    const [scroll, setScroll] = useState(false);
    const newPack = searchParams.get('new') === 'false';
    const type = searchParams.get('type');
    const tripId = searchParams.get('tripId');
    const [loading, setLoading] = useState(false);
    const [cityDrop, setCityDrop] = useState([
        { name: 'Bengaluru', displayName: 'Bengaluru/Bangalore' },
        { name: 'Mysuru', displayName: 'Mysuru/Mysore' }
    ]);
    const [isEdit, setIsEdit] = useState(false);
    const [videoFile, setVideoFile] = useState(null);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);

    // useEffect(() => {
    //     if (!location.state) return;
    //     setFormData(location.state);
    //     setImgData({
    //         oldWallImg: location.state.images,
    //         oldThumbImg: location.state.cardImages
    //     });
    //     setTempData({
    //         included: location.state.included?.join('\n'),
    //         excluded: location.state.excluded?.join('\n'),
    //         terms: location.state.terms?.join('\n'),
    //         safety: location.state.safety?.join('\n'),
    //         carry: location.state?.carry?.join('\n')
    //     });
    //     isDuplicate ? setIsEdit(false) : setIsEdit(true);
    //     //eslint-disable-next-line
    // }, [location.state]);

    useEffect(() => {
        async function getDropCity() {
            try {
                setLoading(true);
                const city = await getDropdownFun('trip', 'Base Cities');
                if (city.data) {
                    setCityDrop(city.data.dropdown);
                }
                setLoading(false);
            } catch (error) {
                errorHandle(error);
            }
        }
        getDropCity();
    }, []);

    useEffect(() => {
        if (newPack) {
            fetchformData(tripId).then((data) => {
                setFormData(data);
                setImgData((prev) => ({
                    ...prev,
                    oldWallImg: data.images,
                    oldThumbImg: data.cardImages
                }));
                setVideoFile(data.videos[0] || null);
                setTempData({
                    included: data.included?.join('\n'),
                    excluded: data.excluded?.join('\n'),
                    terms: data.terms?.join('\n'),
                    safety: data.safety?.join('\n'),
                    carry: data?.carry?.join('\n')
                });
                type === 'duplicate' ? setIsEdit(false) : setIsEdit(true);
                if (type === 'duplicate') {
                    setImgData({
                        oldWallImg: [],
                        oldThumbImg: [],
                        newWallImg: [],
                        newThumbImg: []
                    });
                    setVideoFile(null);
                }
                setLoading(false);
            });
        } else {
            setLoading(false);
        }
    }, [newPack, tripId, type]);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;

            // Set scroll to true if user is not at top
            if (scrollTop > 3000) {
                setScroll(true);
            } else {
                setScroll(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Clean up on unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    async function fetchformData(id) {
        try {
            const result = await orgTripDetailsFun(id);
            return result.data;
        } catch (error) {
            errorHandle(error);
            return null;
        }
    }
    // const handleSubmit = async () => {
    //     const res = await orgPackUpSubmit(formData, tempData, imgData, setLoading, isEdit, videoFile, {
    //         quickViewRef,
    //         imageRef,
    //         inExRef,
    //         safetyRef,
    //         thingsRef,
    //         faqRef,
    //         termsRef,
    //         tagsRef
    //     });
    //     if (res === 200) {
    //         navigate('/org/my-pack');
    //     }
    // };

    const handleScrollToSubmit = () => {
        if (submitRef.current) {
            submitRef.current.scrollIntoView({ behavior: 'smooth' });
            setScroll(true);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setScroll(false);
    };

    return (
        <div className='' style={{ marginTop: '30px' }}>
            {/* <div>
                <button className='backBtn' onClick={() => navigate('/org/my-pack')}>
                    <img src={BackIcon} alt='back' />
                    Back to Account Section
                </button>
            </div> */}
            <label
                style={{
                    color: 'var(--main--font--color)',
                    fontWeight: 600,
                    fontSize: '24px'
                }}
            >
                Property Details
            </label>
            <div className='orgRegisterSecDiv' style={{ marginTop: '15px' }}>
                {loading && (
                    <div className='loadingBackground'>
                        <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                        <h3 style={{ marginTop: -100, fontWeight: 700, color: '#9ca3af' }} className='loadingText'>
                            It might take several minutes please wait...
                        </h3>
                    </div>
                )}
                {/* {isEdit && formData.status === 'active' && (
                    <div className='packEditNote'>
                        <p>
                            <span className='noteSpan'>Note:</span> Since the trip is approved, only certain parts of
                            the data can be edited.
                        </p>
                    </div>
                )} */}
                <div className='sticky-containerPack'>
                    {scroll ? (
                        <button onClick={scrollToTop} title='Scroll to bottom' className='sticky-button'>
                            <img src={UpArrow} alt='scroll to bottom' />
                        </button>
                    ) : (
                        <button onClick={handleScrollToSubmit} title='Scroll to bottom' className='sticky-button'>
                            <img src={DownArrow} alt='scroll to bottom' />
                        </button>
                    )}
                </div>
                {/* <Basic ref={basicRef} formData={formData} setFormData={setFormData} isEdit={isEdit} /> */}

                {/* //Small bold Information which contains slots, type, difficulty, start time, end time,
        // duration, stay, where, food, trek distance */}
                <QuickView ref={quickViewRef} formData={formData} setFormData={setFormData} />
                <ImageUpOrg
                    ref={imageRef}
                    imgData={imgData}
                    setImgData={setImgData}
                    isEdit={isEdit}
                    videoFile={videoFile}
                    setVideoFile={setVideoFile}
                />
                <InEx ref={inExRef} tempData={tempData} setTempData={setTempData} isEdit={isEdit} formData={formData} />
                <Safety ref={safetyRef} tempData={tempData} setTempData={setTempData} isEdit={isEdit} />
                <ThingsToCarry ref={thingsRef} tempData={tempData} setTempData={setTempData} isEdit={isEdit} />
                <FAQ ref={faqRef} formData={formData} setFormData={setFormData} isEdit={isEdit} />
                <Terms ref={termsRef} tempData={tempData} setTempData={setTempData} />
                <Tags data={formData} setData={setFormData} />
                {/* <button ref={submitRef} type='button' className='orgPackUpSubmitBtn blueBtn' onClick={handleSubmit}>
                    Submit
                </button> */}
            </div>{' '}
        </div>
    );
}
